export const SET_NUM = 'SET_NUM'


// WEBPACK FOOTER //
// ./src/store/mutation-type.js